import React from 'react';
import { connect } from 'react-redux';
import { selectors as dashboardSelectors } from '../../../../state/modules/dashboards';
import moment from 'moment';

import DutyPlanner from '../../../../components/schedule/duty-planner/DutyPlanner';
import Loader from '../../../../components/general/Loader';
import Settings from './Settings';

// This is a wrapper class that transforms the duty
// planner into a flexible dashboard widget. To work properly,
// the following properties must be provided to the Duty
// Planner:
// - groupId
// - startTime, endTime (the initial display period)
// - defaultFunctionId (the function used to find candidates)
// - readOnly: Determines whether schedules can be modified from here

// NOTE: For this wrapper the properties are calculated using the Redux store, since
// there is no way to pass the values directly
class DutyPlannerWidget extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      startTime: props.dashboardDateTime.dateTime
    };
  }

  static SettingsContent = Settings;
  static defaultSettings = {
    fixedPeriod: false,
    startHour: 7,
    lookAheadHours: 24,
    lookBackHours: 2
  };

  componentDidUpdate = prevProps => {
    if (prevProps.dashboardDateTime.dateTime !== this.props.dashboardDateTime.dateTime) {
      this.setState({ startTime: this.props.dashboardDateTime.dateTime });
    }
  };

  render = () => {
    if (!this.props.currentGroup || !this.props.dashboardDateTime) return <Loader />;

    const { currentGroup, fixedPeriod, startHour, lookAheadHours, lookBackHours } = this.props;
    const groupId = currentGroup.id;
    let startTime = moment(this.state.startTime);

    // The start time depends on the widget configuration. If the setting 'Fixed Period' is enabled
    // the widget will ignore the dashboard time and align to a specific period. If it is not
    // Fixed, it will use the dashboard hour plus a look back.
    if (fixedPeriod) {
      const periodStart = startTime.clone().startOf('day').add(startHour, 'hours');
      if (startTime.isBefore(periodStart)) startTime.subtract(1, 'day');
      startTime = startTime.startOf('day').add(startHour, 'hours');
    } else {
      startTime = startTime.startOf('hour').subtract(lookBackHours, 'hours');
    }

    startTime = startTime.format();
    const endTime = moment(startTime).add(lookAheadHours, 'hours').format();

    return (
      <DutyPlanner
        {...this.props}
        groupId={groupId}
        startTime={startTime}
        endTime={endTime}
        readOnly={true}
        widgetMode={true}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentGroup: dashboardSelectors.selectCurrentDashboardGroup(state),
  dashboardDateTime: dashboardSelectors.selectDashboardDatetime(state)
});

export default connect(mapStateToProps)(DutyPlannerWidget);
